import React from 'react'

export default function Ebooks() {
  return (
    <div>
      Ebooks
    </div>
  )
}
